var exports = {
  "p_": "x234b8571--4037b1--list",
  "kR": "x234b8571--4037b1--cards",
  "Vn": "x234b8571--4037b1--cards--listed",
  "MW": "x234b8571--4037b1--show-wrapper",
  "aw": "x234b8571--4037b1--slider",
  "x$": "x234b8571--4037b1--slider-list",
};

module.exports = exports;
